import { styled } from "styled-components"
import { useEffect, useRef, useState } from "react"
import useQuizProgress from "../../hooks/QuizPage/useQuizProgress"

const ProgressBar = () => {
  const quizProgress = useQuizProgress()
  const ref = useRef<HTMLDivElement>(null)
  const [lastScrollY, setlastScrollY] = useState(0)
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    const handleScroll = () => {
      let scrollY = window.scrollY

      if (scrollY > lastScrollY) {
        setIsVisible(false)
      } else {
        setIsVisible(true)
      }

      setlastScrollY(scrollY)
    }

    window.addEventListener("wheel", handleScroll)

    return () => {
      window.removeEventListener("wheel", handleScroll)
    }
  }, [lastScrollY])

  return (
    <ProgressDiv ref={ref} $isVisible={isVisible}>
      <StyledProgress value={quizProgress} max={100}></StyledProgress>
    </ProgressDiv>
  )
}

export default ProgressBar

const ProgressDiv = styled.div<{ $isVisible: boolean }>`
  width: 100%;
  height: 50px;
  background-color: white;
  position: fixed;
  top: 60px;
  left: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  ${(props) => !props.$isVisible && "transform: translateY(-60px)"}
`

const StyledProgress = styled.progress`
  width: 70%;
  height: 20px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: white;

  &::-webkit-progress-bar {
    background: var(--custom-white-smoke);
    border-radius: 20px;
    border: solid 2px var(--custom-light-blue);
    overflow: hidden;
  }

  &::-webkit-progress-value {
    background: var(--custom-light-blue);
    border-radius: 20px;
    transition: all 0.3s ease;
  }
`
